module.exports = __webpack_public_path__ + "img/ayan_nag-frosty-glaze.915d16c.jpg";